/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getEspecialties } from 'app/entities/especialty/especialty.reducer';
import { createEntity, getEntity, reset, updateEntity } from './doctor-especialty.reducer';

export const DoctorEspecialtyUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const doctors = useAppSelector(state => state.doctor.entities);
  const especialties = useAppSelector(state => state.especialty.entities);
  const doctorEspecialtyEntity = useAppSelector(state => state.doctorEspecialty.entity);
  const loading = useAppSelector(state => state.doctorEspecialty.loading);
  const updating = useAppSelector(state => state.doctorEspecialty.updating);
  const updateSuccess = useAppSelector(state => state.doctorEspecialty.updateSuccess);

  const handleClose = () => {
    navigate(`/doctor-especialty${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDoctors({}));
    dispatch(getEspecialties({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.createdDtm !== undefined && typeof values.createdDtm !== 'number') {
      values.createdDtm = Number(values.createdDtm);
    }
    if (values.joiningDt !== undefined && typeof values.joiningDt !== 'number') {
      values.joiningDt = Number(values.joiningDt);
    }
    if (values.leavingDt !== undefined && typeof values.leavingDt !== 'number') {
      values.leavingDt = Number(values.leavingDt);
    }
    if (values.consultationCharge !== undefined && typeof values.consultationCharge !== 'number') {
      values.consultationCharge = Number(values.consultationCharge);
    }
    if (values.followupCharge !== undefined && typeof values.followupCharge !== 'number') {
      values.followupCharge = Number(values.followupCharge);
    }
    if (values.followupDay !== undefined && typeof values.followupDay !== 'number') {
      values.followupDay = Number(values.followupDay);
    }
    if (values.followupVisit !== undefined && typeof values.followupVisit !== 'number') {
      values.followupVisit = Number(values.followupVisit);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...doctorEspecialtyEntity,
      ...values,
      doctorId: doctors.find(it => it.id.toString() === values.doctorId?.toString()),
      especialtyCode: especialties.find(it => it.id.toString() === values.especialtyCode?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...doctorEspecialtyEntity,
          doctorId: doctorEspecialtyEntity?.doctorId?.id,
          especialtyCode: doctorEspecialtyEntity?.especialtyCode?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.doctorEspecialty.home.createOrEditLabel" data-cy="DoctorEspecialtyCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.doctorEspecialty.home.createOrEditLabel">Create or edit a DoctorEspecialty</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="doctor-especialty-id"
                  label={translate('tinyMedicRestApp.doctorEspecialty.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorEspecialty.departmentCode')}
                id="doctor-especialty-departmentCode"
                name="departmentCode"
                data-cy="departmentCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 25, message: translate('entity.validation.maxlength', { max: 25 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorEspecialty.active')}
                id="doctor-especialty-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorEspecialty.createdDtm')}
                id="doctor-especialty-createdDtm"
                name="createdDtm"
                data-cy="createdDtm"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorEspecialty.createdBy')}
                id="doctor-especialty-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
                validate={{
                  maxLength: { value: 45, message: translate('entity.validation.maxlength', { max: 45 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorEspecialty.modifiedBy')}
                id="doctor-especialty-modifiedBy"
                name="modifiedBy"
                data-cy="modifiedBy"
                type="text"
                validate={{
                  maxLength: { value: 45, message: translate('entity.validation.maxlength', { max: 45 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorEspecialty.joiningDt')}
                id="doctor-especialty-joiningDt"
                name="joiningDt"
                data-cy="joiningDt"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorEspecialty.leavingDt')}
                id="doctor-especialty-leavingDt"
                name="leavingDt"
                data-cy="leavingDt"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorEspecialty.consultationCharge')}
                id="doctor-especialty-consultationCharge"
                name="consultationCharge"
                data-cy="consultationCharge"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorEspecialty.followupCharge')}
                id="doctor-especialty-followupCharge"
                name="followupCharge"
                data-cy="followupCharge"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorEspecialty.followupDay')}
                id="doctor-especialty-followupDay"
                name="followupDay"
                data-cy="followupDay"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorEspecialty.followupVisit')}
                id="doctor-especialty-followupVisit"
                name="followupVisit"
                data-cy="followupVisit"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorEspecialty.timestampentry')}
                id="doctor-especialty-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorEspecialty.microSec')}
                id="doctor-especialty-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorEspecialty.lastupdated')}
                id="doctor-especialty-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorEspecialty.cursor')}
                id="doctor-especialty-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="doctor-especialty-doctorId"
                name="doctorId"
                data-cy="doctorId"
                label={translate('tinyMedicRestApp.doctorEspecialty.doctorId')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="doctor-especialty-especialtyCode"
                name="especialtyCode"
                data-cy="especialtyCode"
                label={translate('tinyMedicRestApp.doctorEspecialty.especialtyCode')}
                type="select"
                required
              >
                <option value="" key="0" />
                {especialties
                  ? especialties.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/doctor-especialty" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DoctorEspecialtyUpdate;
